/* eslint-disable import/prefer-default-export */
import Vue from "vue";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import { store } from "../store/store";

let stompClient = null;
export const notifications = new Vue({
  methods: {
    connectToSocket() {
      console.log("creating connection");
      let socket = new SockJS("http://192.168.2.61:8087/test");
      stompClient = Stomp.over(socket);
      stompClient.connect({}, function(frame) {
        console.log("Connected: " + frame);
        stompClient.subscribe("/topic/greetings", function(greeting) {
          console.log("greeting >>>>>>>>>>>>", greeting.body);
          store.dispatch(
            "notifications/setNotification",
            JSON.parse(greeting.body)
          );
        });
        stompClient.subscribe("/user/topic/greetings", function(greeting) {
          console.log("greetings in user/greetings >>>", greeting.body);
          store.dispatch(
            "notifications/setNotification",
            JSON.parse(greeting.body)
          );
        });
      });
    },
    disconnectSocket() {
      if (stompClient !== null) {
        stompClient.disconnect();
      }
    },
    sendMessage(message) {
      stompClient.send("/app/hello", message, {});
    }
  }
});
